module.exports = __webpack_public_path__ + "static/img/050202.ec289ea0.png";